// eslint-disable-next-line no-use-before-define
import { useMutation, useQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';
import { registrationPath } from '../Helper';
import SocialGeographicHistoryForm from './SocialGeographicHistoryForm';
import { REGISTRATION_SOCIAL_GEO_HIST_QUERY, UPDATE_REGISTRATION } from './SocialGeographicHistoryQueries';

interface Props {
  exitForm: (status: boolean) => void;
}

const SocialGeographicHistory = (props: Props): JSX.Element => {
  const { exitForm } = props;
  const { patientId } = useParams<{ patientId: string }>();
  const [updateRegistration] = useMutation(UPDATE_REGISTRATION);
  const { data, error } = useQuery(REGISTRATION_SOCIAL_GEO_HIST_QUERY, {
    variables: { id: patientId },
  });

  if (error || !data) return <></>;
  const { patient, countryRefData, user } = data;

  const updateField = (field: string, value: string | boolean | number) => {
    if (field === 'inThisStateAllYear' && value === true) {
      updateRegistration({
        variables: {
          patientId,
          inThisStateAllYear: true,
          alternateAddressPhone: '',
        },
      });
      return;
    }

    updateRegistration({
      variables: {
        patientId,
        [field]: value,
      },
    });
  };

  return (
    <SocialGeographicHistoryForm
      updateField={updateField}
      patient={patient}
      refData={{
        countryRefData,
      }}
      handleShowSaveExitConfirm={() => exitForm(true)}
      previousPageLink={registrationPath(patient.id, 'demographics')}
      isPso={user.isPso}
    />
  );
};

export default SocialGeographicHistory;
